import createListDataFetchManagementStoreSlice from '../../../modules/utilities/store/slices/listDataFetchManagement'

const sliceName = 'chatManagementExperience.messageList'

const ChatManagementMessageListSlice = createListDataFetchManagementStoreSlice(
  sliceName
)

export default ChatManagementMessageListSlice
